import type { DisposableImageSource } from "@/libs/cv"
import { writable } from "svelte/store"
import type { CaptureMetadata } from "../api"

export type ImageCapture = {
  source: DisposableImageSource
  visibleRect?: {
    x: number
    y: number
    width: number
    height: number
  }
  metadata: Partial<CaptureMetadata>
}

/** Captured imge candidates */
export const captures = {
  ...writable<ImageCapture[]>([]),

  push(capture: ImageCapture) {
    this.update((captures) => [...captures, capture])
  },

  clear(cleanup: (capture: ImageCapture) => void = () => {}) {
    this.update((captures) => {
      for (const capture of captures) cleanup(capture)

      return []
    })
  },
}
